import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface CreateBuildingsVariables {
  groupId: string;
  input: string;
}

export interface CreateBuildingsResult {
  id: string;
  name: string;
}

export interface RawResult {
  createBuildings: CreateBuildingsResult[];
}

export const createGroupBuildings = async <V>(
  apollo: DollarApollo<V>,
  groupId: string,
  input: string
): Promise<FetchResult<RawResult>> => {
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: { groupId, input },
    errorPolicy: "all"
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
